module.exports = __webpack_public_path__ + "static/media/face4.d5afaa66.jpg";